import React, { useEffect, useState } from "react";
import { Row, Col, Table, Typography, Divider, Button, Tag } from "antd";
import Location from "./Location.svg";
import moment from "moment";
import ViewDetails from "./ViewDetails/index";
import Live from "./live.gif";
import axios from "axios";
const { Title, Text } = Typography;

export default function SessionDetails({ data }) {
  const [dataSource, setDataSource] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [sessionId, setSessionId] = useState(null);
  const [modalData, setModalData] = useState({});
  const handleViewDetails = (text) => {
    setSessionId(text?.sessionId);
    fetchLatestData(text?.sessionId);
    showModal();
  };

  const fetchLatestData = (sessionId) => {
    const user = localStorage.getItem("user");
    const token = JSON.parse(user).access_token;
    // setLoading(true);
    axios
      .get(
        `${process.env.REACT_APP_API_SERVICE}analytics/details/${sessionId}?token=${token}`
      )
      .then((res) => {
        // setLoading(false);
        setModalData(res.data);
      })
      .catch((err) => {
        // setLoading(false);
        console.log(err);
      });
  };
  const Visitor = ({ text }) => (
    <>
      <Row align="middle">
        <Col>
          {" "}
          <Title level={5}>{text?.name}</Title>{" "}
        </Col>
        <Col push={1}>
          {/* {text?.live && (
           <Tag
              color="green"
              style={{ borderRadius: 32, padding: "2px 10px" }}
            >
              Live
            </Tag>
          )} */}

          {text?.live && (
            <img
              width={40}
              height={40}
              style={{ marginBottom: "5px" }}
              src={Live}
              alt="live"
            />
          )}
        </Col>
      </Row>
      <Row>
        <Text type="secondary">{text?.session_start_date}</Text>
      </Row>
    </>
  );
  const LocationComponent = ({ text }) => (
    <>
      <Row align="middle">
        <Col>
          <img src={Location} alt="location" />
        </Col>
        <Col push={2}>
          <Row>
            <Title level={5}>{text?.name}</Title>
          </Row>
         
        </Col>
      </Row>
    </>
  );
  const Summary = ({ text }) =>
    text?.opened || text?.shortlisted || text?.queries ? (
      <>
        <Row align="middle"  >
          <Col span={5}>
            <Row justify="center">
              <Text type="secondary"> Opened</Text>
            </Row>
            <Row justify="center">
              {text?.opened ? <Text>{text?.opened} Products</Text> : "- -"}
            </Row>
          </Col>
          <Divider style={{ height: 50 }} type="vertical" />
          <Col span={5}>
            <Row justify="center">
              <Text type="secondary"> Shortlisted</Text>
            </Row>
            <Row justify="center">
              {text?.shortlisted ? (
                <Text>{text?.shortlisted} Products</Text>
              ) : (
                "- -"
              )}
            </Row>
          </Col>
          <Divider style={{ height: 50 }} type="vertical" />
          <Col span={5}>
            <Row justify="center">
              <Text type="secondary"> Sent</Text>
            </Row>
            <Row justify="center">
              {text?.queries ? <Text>{text?.queries} queries</Text> : "- -"}
            </Row>
          </Col>

          <Col span={5}>
            <Button size="middle" onClick={() => handleViewDetails(text)}>
              View Details
            </Button>
          </Col>
        </Row>
      </>
    ) : (
      <>
        <Row justify="center">
          <Col>
            <Text>No activity</Text>
          </Col>
        </Row>
      </>
    );
  useEffect(() => {
    if (data) {
      const dataSource = data.sessions.map((item) => {
        return {
          visitor: {
            name: item?.visitor_email,
            session_start_date:
              item?.session_start_date &&
              moment(item?.session_start_date).format("h:mm a, MMMM Do YYYY"),
            live: item?.live,
          },
          location: {
            name: item?.session_location,
            
          },
          duration:
          item?.session_duration &&
          moment.utc(item?.session_duration * 1000).format("HH:mm:ss"),
          summary: {
            queries: item?.num_enquiries,
            opened: item?.num_products_opened,
            shortlisted: item?.num_products_shortlisted,
            open_product_modal: item?.open_product_modal,
            send_query: item?.send_query,
            shortlist_product: item?.shortlist_product,
            sessionId: item?.sessionId,
           
          },
        };
      });

      setDataSource(dataSource);
    }
  }, [data]);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };
  const columns = [
    {
      title: "Visitor details",
      dataIndex: "visitor",
      key: "visitor",
      width:'30%',
      render: (text) => <Visitor text={text} />,
    },
    {
      title: "Location",
      dataIndex: "location",
      key: "location",
      width:'20%',
      render: (text) => <LocationComponent text={text} />,
    },
    {
      title: "Duration",
      dataIndex: "duration",
      width:'10%',
      key: "duration",
      // render: (text) => <LocationComponent text={text} />,
    },
    {
      title: "Activity summary",
      dataIndex: "summary",
      key: "summary",
      width:'40%',
      align:"center",
      render: (text) => <Summary text={text} />,
    },
  ];

  return (
    <div>
      <ViewDetails
        modalData={modalData}
        dataSource={dataSource}
        isModalVisible={isModalVisible}
        showModal={showModal}
        handleOk={handleOk}
        handleCancel={handleCancel}
        sessionId={sessionId}
      />
      <Row style={{ marginTop: "2em" }}>
        <Title level={4}>Session Details</Title>
      </Row>
      <Row>
        <Col span={24}>
          <Table
            columns={columns}
            dataSource={dataSource}
            pagination={{ position: ["bottomCenter"] }}
           
          />
        </Col>
      </Row>
    </div>
  );
}
